import { IBalanceState } from '@signature-it/ngx-generic/interfaces';

export class BalanceStateModel implements IBalanceState {
    amount: number;

    constructor(attributes?: object) {
        attributes = attributes || {};

        this.amount = Number(attributes['amount']) || 0;
    }

}
